import { useState } from 'react'
import { renderToString } from 'react-dom/server'
import { useClipboard } from '@chakra-ui/hooks'
import { Button } from '../button'
import { TextArea } from '../textarea'
import {
  StyledSharePanelContainer,
  StyledSharePanelFooter
} from './CommonSharePanelStyles'
import { StyledEmbedTextAreaContainer } from './EmbedSharePanel.styles'
import { ShareIframe } from './ShareIframe'

export interface EmbedSharePanelProps {
  onCopy: (value: string) => void
  url: string
}

export function EmbedSharePanel(props: EmbedSharePanelProps) {
  const [value, setValue] = useState(
    renderToString(<ShareIframe url={props.url} />)
  )
  const { onCopy, hasCopied } = useClipboard(value)

  return (
    <StyledSharePanelContainer>
      <StyledEmbedTextAreaContainer>
        <TextArea
          value={value}
          onChange={e => setValue(e.currentTarget.value)}
        />
      </StyledEmbedTextAreaContainer>
      <StyledSharePanelFooter>
        <Button
          //@ts-expect-error
          text={hasCopied ? 'Code copied' : 'Copy code'}
          onClick={() => {
            onCopy()
            props.onCopy(value)
          }}
        />
      </StyledSharePanelFooter>
    </StyledSharePanelContainer>
  )
}
